import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
  },
});
